/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pSearch.vue?vue&type=template&id=546eb4e6"
import script from "./pSearch.vue?vue&type=script&lang=js"
export * from "./pSearch.vue?vue&type=script&lang=js"
import style0 from "./pSearch.vue?vue&type=style&index=0&id=546eb4e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports